import _JSON$stringify from "/app/node_modules/babel-runtime/core-js/json/stringify";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "vuelidate/lib/validators";
import { ConflictError, BadRequestError } from "~/abstractions/errors";
import { lettersAndNumbersMixin } from "~/mixins";
import { charactersSpecial } from "~/validators";

export default {
  mixins: [lettersAndNumbersMixin],
  data: function data() {
    return {
      dialog: false,
      switchState: false,
      temp: false,
      multi: false,
      title: "Nuevo Equipo",
      teamName: "",
      sending: false,
      actionButton: "",
      value: null,
      loading: true,
      idTeam: null,
      message: "",
      validTeamName: false,
      conditionalShowMessageStatus: false,
      isHaveNotSellers: false,
      resultValidNameService: false,
      channelIsActive: true,
      teamIsActive: ""
    };
  },
  validations: function validations() {
    return {
      teamName: {
        required: required,
        charactersSpecial: charactersSpecial("teamName")
      }
    };
  },

  methods: {
    addModalConfig: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.dialog = true;
                this.title = "Nuevo Equipo";
                this.actionButton = "Crear";
                this.conditionalShowMessageStatus = false;
                this.loading = true;
                if (this.channelIsActive == true) {
                  this.switchState = true;
                } else {
                  this.switchState = false;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addModalConfig() {
        return _ref.apply(this, arguments);
      }

      return addModalConfig;
    }(),
    editModalConfig: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.dialog = true;
                this.title = "Editar Equipo";
                this.actionButton = "Guardar";

                //this.$isBoss()
                this.loading = false;

                _context2.next = 6;
                return this.$store.dispatch("team/findTeamForEdit", this.idTeam);

              case 6:
                response = _context2.sent;

                this.teamName = response.Name;
                this.switchState = response.IsActive;
                this.temp = response.TemporaryRegistration;
                this.multi = response.MulticomercioRegistration;
                this.value = response.IdChannel;

                if (response.IsActive == false) {
                  this.conditionalShowMessageStatus = false;
                }
                this.resultValidNameService = true;

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function editModalConfig() {
        return _ref2.apply(this, arguments);
      }

      return editModalConfig;
    }(),
    onSubmit: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.$v.$touch();

                _context3.prev = 1;

                if (!(this.title === "Nuevo Equipo")) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 5;
                return this.$store.dispatch("team/createdNewTeam", {
                  id: this.value,
                  name: this.teamName,
                  temporaryRegistration: this.temp,
                  multicomercioRegistration: this.multi,
                  isActive: this.switchState
                });

              case 5:
                if (this.$isAdmin() || this.$isAdminCollaborator()) {
                  this.$emit("upDateListBoss");
                  this.$emit("notShowContent");
                } else if (this.$isBoss() == true) {
                  this.$emit("updateShowChannels", this.value);
                  this.$store.commit("channel/updateTeamsForBoss", this.value);
                }
                _context3.next = 11;
                break;

              case 8:
                _context3.next = 10;
                return this.$store.dispatch("team/editTeam", {
                  idChannel: this.value,
                  idTeam: this.idTeam,
                  name: this.teamName,
                  temporaryRegistration: this.temp,
                  multicomercioRegistration: this.multi,
                  isActive: this.switchState
                });

              case 10:
                if (this.$isBoss() == true) {
                  data = {
                    id: this.value
                  };

                  this.$emit("toTeamsTable", {
                    val: { name: this.teamName, active: this.switchState }
                  });
                }

              case 11:
                this.$emit("upDateTeam");
                this.$emit("completeForm");
                this.cancel();
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](1);

                if (_context3.t0 instanceof ConflictError) {
                  if (this.title === "Nuevo Equipo") {
                    this.$swal("No se pudo Crear", _context3.t0.message, "warning");
                  } else {
                    this.$swal("No se pudieron guardar tus cambios", _context3.t0.message, "warning");
                  }
                } else if (_context3.t0 instanceof BadRequestError) {
                  this.$swal("Error", _JSON$stringify(_context3.t0.data.constraints[0].constraints.isEmail), "warning");
                } else {
                  this.$controlMessage(_context3.t0);
                }

              case 19:
                this.cancel();
                this.dialog = false;

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 16]]);
      }));

      function onSubmit() {
        return _ref3.apply(this, arguments);
      }

      return onSubmit;
    }(),
    cancel: function cancel() {
      this.dialog = false;
      this.teamName = "";
      this.temp = false;
      this.multi = false;
      this.switchState = false;
      this.$v.$reset();
    },
    validName: function validName() {
      var _this = this;

      clearTimeout(this.timeout);
      if (this.nameChannel === "") return true;
      this.timeout = setTimeout(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!(_this.title == "Nuevo Equipo")) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 4;
                return _this.$store.dispatch("team/teamValidNewTeam", {
                  idChannel: _this.value,
                  name: _this.teamName
                });

              case 4:
                _context4.next = 8;
                break;

              case 6:
                _context4.next = 8;
                return _this.$store.dispatch("team/validEditTeam", {
                  idChannel: _this.value,
                  idTeam: _this.idTeam,
                  name: _this.teamName
                });

              case 8:
                _this.resultValidNameService = true;
                _context4.next = 15;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](0);

                _this.message = _context4.t0.message;
                _this.resultValidNameService = false;

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this, [[0, 11]]);
      })), 500);
    }
  },
  computed: {
    teamNameErrorMessages: function teamNameErrorMessages() {
      var errors = [];
      if (!this.$v.teamName.$dirty) return errors;
      !this.$v.teamName.required && errors.push("Campo obligatorio"), !this.$v.teamName.charactersSpecial && errors.push("Caracter inválido"), !this.resultValidNameService && errors.push(this.message);
      return errors;
    },
    teamIsActiveChange: function teamIsActiveChange() {
      if (this.$route.query.bossStatus) {
        this.teamIsActive = this.$route.query.bossStatus;
      } else if (this.$route.query.channelStatus) {
        this.teamIsActive = this.$route.query.channelStatus;
      } else if (this.$isBoss()) {
        this.teamIsActive = false;
      } else {
        this.teamIsActive = false;
      }
    }
  },
  watch: {
    switchState: function switchState(val) {
      if (val == false && this.isHaveNotSellers == false) {
        this.conditionalShowMessageStatus = true;
      } else {
        this.conditionalShowMessageStatus = false;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.teamIsActiveChange;
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/new-team-modal.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/new-team-modal.vue
// module chunks = 4 6 8